import { forwardRef, memo, useCallback } from "react";
import { Input, InputProps } from "../../Input";

export type CardCVCFieldProps = Omit<InputProps<any>, "onChange" | "value"> & {
  onChange?: (value: string) => void,
  value?: string,
}

export const CardCVCField = memo<CardCVCFieldProps>(forwardRef<any, CardCVCFieldProps>((
  {
    onChange,
    value,
    ...props
  }, ref) => {
  const wrappedOnChange = useCallback((e: any) => onChange?.((e?.target?.value || "").replace(/\D/g, "")), [ onChange ]);

  return <Input
    component="input"
    autoComplete="cc-csc"
    autoCorrect="off"
    spellCheck="false"
    inputMode="numeric"
    placeholder="CVC"
    {...props}
    value={value || ""}
    ref={ref}
    type="text"
    onChange={wrappedOnChange}
  />;
}));

export default CardCVCField;
